import { PageHeader } from "@/components/StatCard";
import { Stat, Section, Loading, Empty, useFetch, money, day } from "./_shared";

export default function Collab() {
  const { data: ov, loading } = useFetch("/admin/collab/overview");
  const { data: conns } = useFetch("/admin/collab/connections?limit=50");
  const { data: offs } = useFetch("/admin/collab/offerings?limit=50");
  if (loading) return <Loading />;
  const t = ov?.totals || {}; const rev = ov?.revenue || {};
  const connections = conns?.connections || []; const offerings = offs?.offerings || [];

  return (
    <div className="space-y-5">
      <PageHeader eyebrow="Admin" title="Collab" subtitle="Kooperationen, Angebote & Umsatz." />
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
        <Stat label="Verbindungen" value={t.requests_accepted ?? 0} />
        <Stat label="Angebote" value={t.offerings_total ?? 0} />
        <Stat label="Coaches beteiligt" value={t.coaches_involved ?? 0} />
        <Stat label="Umsatz gesamt" value={money(rev.all_time_cents)} />
      </div>

      <Section title={`Angebote (${offerings.length})`} testId="admin-collab-offerings">
        {offerings.length === 0 ? <Empty text="Keine Collab-Angebote." /> : (
          <div className="space-y-2">
            {offerings.map((o) => (
              <div key={o.id} className="flex items-center justify-between gap-3 rounded-xl border border-border bg-background p-3">
                <div className="min-w-0"><p className="truncate text-sm font-medium text-foreground">{o.title || "—"}<span className="ml-1 rounded bg-secondary px-1.5 text-[10px] text-muted-foreground">{o.status}</span></p><p className="truncate text-xs text-muted-foreground">{(o.coaches || []).map((c) => c.name).filter(Boolean).join(", ")}{o.price_cents ? ` · ${money(o.price_cents)}` : ""} · {o.purchases || 0} Käufe</p></div>
                <span className="shrink-0 text-sm font-semibold text-foreground">{money(o.revenue_cents)}</span>
              </div>
            ))}
          </div>
        )}
      </Section>

      <Section title={`Verbindungen (${connections.length})`} testId="admin-collab-connections">
        {connections.length === 0 ? <Empty text="Keine Verbindungen." /> : (
          <div className="space-y-2">
            {connections.map((c) => (
              <div key={c.id} className="flex items-center justify-between gap-3 rounded-xl border border-border bg-background p-3 text-sm">
                <span className="truncate text-foreground">{c.from_coach?.name} → {c.to_coach?.name}</span>
                <span className="shrink-0 text-xs text-muted-foreground">{c.status} · {day(c.created_at)}</span>
              </div>
            ))}
          </div>
        )}
      </Section>
    </div>
  );
}
